import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import StatusDropdown from './StatusDropdown';
import AssigneePicker from './AssigneePicker';

const GlobalTaskDetailModal = ({ isOpen, onClose, task, token, onUpdate }) => {
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState(task || {});
  const [loading, setLoading] = useState(false);

  if (!isOpen || !task) return null;

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/global-tasks/${task.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          title: formData.title,
          description: formData.description,
          status: formData.status,
          assignee: formData.assignee,
          dueDate: formData.dueDate
        })
      });
      
      if (response.ok) {
        onUpdate();
        setEditMode(false);
      }
    } catch (error) {
      console.error('Failed to update task:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return '';
    return dateStr.split('T')[0];
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">Global Task Details</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Title</label>
            {editMode ? (
              <input
                type="text"
                className="input"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                data-testid="edit-task-title"
              />
            ) : (
              <div style={{ fontSize: '16px', fontWeight: 600 }}>{task.title}</div>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Description</label>
            {editMode ? (
              <textarea
                className="input"
                rows="4"
                value={formData.description || ''}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                data-testid="edit-task-description"
              />
            ) : (
              <div>{task.description || 'No description'}</div>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Status</label>
            {editMode ? (
              <StatusDropdown
                value={formData.status}
                onChange={(newStatus) => setFormData({ ...formData, status: newStatus })}
              />
            ) : (
              <span className={`status-pill status-${task.status?.toLowerCase().replace(' ', '-')}`}>
                {task.status}
              </span>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Assignee</label>
            {editMode ? (
              <AssigneePicker
                assignees={formData.assignee ? [formData.assignee] : []}
                onChange={(assignees) => setFormData({ ...formData, assignee: assignees[0] || null })}
                token={token}
              />
            ) : (
              <div>{task.assignee || 'Not assigned'}</div>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Due Date</label>
            {editMode ? (
              <input
                type="date"
                className="input"
                value={formatDateForInput(formData.dueDate)}
                onChange={(e) => setFormData({ ...formData, dueDate: e.target.value ? new Date(e.target.value).toISOString() : null })}
                data-testid="edit-task-duedate"
              />
            ) : (
              <div>{task.dueDate ? new Date(task.dueDate).toLocaleDateString() : 'No due date'}</div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          {editMode ? (
            <>
              <button className="btn btn-secondary" onClick={() => { setEditMode(false); setFormData(task); }} disabled={loading}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleUpdate} disabled={loading}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
              <button className="btn btn-primary" onClick={() => setEditMode(true)}>
                Edit
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GlobalTaskDetailModal;